"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Heading = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreMixins = require("@legacy-vfuk/core-mixins");

var _Heading = _interopRequireDefault(require("../themes/Heading.theme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var levelToSize = {
  1: 5,
  2: 4,
  3: 3,
  4: 2,
  5: 1
};

var Heading = _styledComponents["default"].h2.withConfig({
  displayName: "Headingstyle__Heading",
  componentId: "sc-12vluu2-0"
})(function (props) {
  var localTheme = (0, _Heading["default"])(props.theme);
  return (0, _styledComponents.css)(["color:", ";", " ", " ", " ", " &:last-child{margin-bottom:0;}"], localTheme.appearance[props.appearance].color, _coreMixins.typography.heading(props.size || levelToSize[props.level], !props.noMargin), props.weight && "\n      font-weight: ".concat(props.theme.fontWeight[props.weight], ";\n    "), props.justify && "\n      text-align: ".concat(props.justify, ";\n    "), props.inverse && "\n      color: ".concat(localTheme.appearance[props.appearance].inverse.color, ";\n    "));
});

exports.Heading = Heading;
//# sourceMappingURL=Heading.style.js.map